module.exports = "<div class=\"row\">\n  <lk-cover-card [cover]=\"cover\"></lk-cover-card>\n  <lk-users-card [users]=\"users\"></lk-users-card>\n  <lk-article-card *ngFor=\"let article of articles\" [article]=\"article\" [publication]=\"publication\"></lk-article-card>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/front-page/front-page.component.html
// module id = 209
// module chunks = 1